module.exports = __webpack_public_path__ + "static/media/YF72_3.1166327a.jpg";